import { BuyerStatus } from '@choco-admin/types';

export interface BuyerStatusPresentation {
  /** Chip text. */
  label: string;
  /** Tooltip copy — says what the status means and who, if anyone, must act. */
  description: string;
  color: 'success' | 'default';
}

/**
 * How a buyer's status should read to the person looking at it.
 *
 * The raw values are the backend's (`active` | `pending`), and `pending` used to
 * surface as the literal string "pending_approval" — which invented an approval
 * queue that does not exist and had CS looking for something to approve.
 */
export const getBuyerStatusPresentation = (
  status: BuyerStatus
): BuyerStatusPresentation =>
  status === BuyerStatus.ACTIVE
    ? {
        label: 'Active',
        description: 'This buyer has an active user linked and can be used.',
        color: 'success',
      }
    : {
        label: 'Pending activation',
        description:
          'No active user is linked to this buyer yet. It activates by itself as soon as one is linked. Linking a user who is still pending does not activate it.',
        color: 'default',
      };
